import { createSlice } from '@reduxjs/toolkit';

import {
  getAnalyticsMapsDataApi,
  getTotalCustomersApi,
  getTotalUsersApi,
  getVerifiedStoresApi,
  getPlusFeaturesDataApi,
  getCustomerAnalyticApi,
  getActiveUserApi,
  getStateAnalyticsApi,
  getAreaAnalyticsApi,
  getTrafficAnalayticApi,
  getPlusFeatureAnalyticApi,
  getAdvertisementAnalyticApi,
  getPlusFeatureAnalyticByCityApi,
  getCategoriesAnalyticApi,
  getPlusFeatureAnalyticTypesApi,
  getPartnerAnalyticApi,
  getPartnerUsersApi,
  getBuyVehicleImpressionApi,
  getBuyVehicleAllApi
} from './analyticsApi';

// ----------------------------------------------------------------------

const initialState = {
  iscustomerLoading: false,
  analyticList: [],
  customerList: [],
  totalUsersList: {},
  verifiedStores: {},
  analyticsStoreData: [],
  getCustomerAnalytic: [],
  getActiveUserResult: [],
  getTrafficAnalaytic: [],
  getPlusFeatureAnalytic: [],
  getAdvertisementAnalytic: [],
  getStateAnalytics: [],
  getAreaAnalytics: [],
  plusFeatureAnalyticByCity: [],
  getCategoriesAnalytic: [],
  getPlusFeatureAnalyticTypes: [],
  getPartnerAnalytic: [],
  getBuyVehicleImpression: [],
  getBuyVehicleAll: [],
  getPartnerUsers: {},
  plusFeatureData: {}
};

const slice = createSlice({
  name: 'allCustomer',
  initialState,
  reducers: {},
  extraReducers: {
    [getTotalCustomersApi.pending]: (state) => {
      state.iscustomerLoading = true;
    },
    [getTotalCustomersApi.fulfilled]: (state, action) => {
      state.customerList = action.payload;
      state.iscustomerLoading = false;
    },
    [getTotalCustomersApi.rejected]: (state) => {
      state.iscustomerLoading = false;
    },
    [getTotalUsersApi.pending]: (state) => {
      state.iscustomerLoading = true;
    },
    [getTotalUsersApi.fulfilled]: (state, action) => {
      state.totalUsersList = action.payload;
      state.iscustomerLoading = false;
    },
    [getVerifiedStoresApi.rejected]: (state) => {
      state.iscustomerLoading = false;
    },
    [getVerifiedStoresApi.pending]: (state) => {
      state.iscustomerLoading = true;
    },
    [getVerifiedStoresApi.fulfilled]: (state, action) => {
      state.verifiedStores = action.payload;
      state.iscustomerLoading = false;
    },
    [getAnalyticsMapsDataApi.fulfilled]: (state, action) => {
      state.analyticsStoreData = action.payload;
    },
    [getPlusFeaturesDataApi.pending]: (state) => {
      state.iscustomerLoading = true;
    },
    [getPlusFeaturesDataApi.fulfilled]: (state, action) => {
      state.plusFeatureData = action.payload;
      state.iscustomerLoading = false;
    },
    [getCustomerAnalyticApi.fulfilled]: (state, action) => {
      state.getCustomerAnalytic = action.payload;
    },
    [getActiveUserApi.fulfilled]: (state, action) => {
      state.getActiveUserResult = action.payload;
    },
    [getStateAnalyticsApi.fulfilled]: (state, action) => {
      state.getStateAnalytics = action.payload;
    },
    [getAreaAnalyticsApi.fulfilled]: (state, action) => {
      state.getAreaAnalytics = action.payload;
    },
    [getTrafficAnalayticApi.fulfilled]: (state, action) => {
      state.getTrafficAnalaytic = action.payload;
    },
    [getPlusFeatureAnalyticApi.fulfilled]: (state, action) => {
      state.getPlusFeatureAnalytic = action.payload;
    },
    [getAdvertisementAnalyticApi.fulfilled]: (state, action) => {
      state.getAdvertisementAnalytic = action.payload;
    },
    [getPlusFeatureAnalyticByCityApi.fulfilled]: (state, action) => {
      state.plusFeatureAnalyticByCity = action.payload;
    },
    [getCategoriesAnalyticApi.fulfilled]: (state, action) => {
      state.getCategoriesAnalytic = action.payload;
    },
    [getPlusFeatureAnalyticTypesApi.fulfilled]: (state, action) => {
      state.getPlusFeatureAnalyticTypes = action.payload;
    },
    [getPartnerAnalyticApi.fulfilled]: (state, action) => {
      state.getPartnerAnalytic = action.payload;
    },
    [getBuyVehicleImpressionApi.fulfilled]: (state, action) => {
      state.getBuyVehicleImpression = action.payload;
    },
    [getBuyVehicleAllApi.fulfilled]: (state, action) => {
      state.getBuyVehicleAll = action.payload;
    },
    [getPartnerUsersApi.fulfilled]: (state, action) => {
      state.getPartnerUsers = action.payload;
    }
  }
});
export const customerActions = slice.actions;

export default slice.reducer;
